export const DEFAULT_AI_AGENT_NAME = 'Ametista';

export function resolveAgentName(
  context?: { agency: { aiAgentName?: string | null } | undefined | null } | undefined | null
): string {
  const name = context?.agency?.aiAgentName;
  if (name && name.trim().length > 0) {
    return name.trim();
  }
  return DEFAULT_AI_AGENT_NAME;
}
